var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import { removeTabs } from "./constant";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import di from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import { useNavigate } from "react-router-dom";
import { getQueryParameterName, } from "@frameworks/salesjourney/utils/genericMethods";
import Spinner from "react-bootstrap/Spinner";
var LeadViewTabs = function (props) {
    var _a;
    var tabFlag = getQueryParameterName("tabFlag");
    var navigate = useNavigate();
    var leadTabList = removeTabs();
    var _b = __read(React.useState(props.flag ? props.flag : (_a = leadTabList[0]) === null || _a === void 0 ? void 0 : _a.eventKey), 2), tab = _b[0], setTab = _b[1];
    React.useEffect(function () {
        if (tabFlag) {
            setTab(tabFlag);
        }
    }, [tabFlag]);
    var getSelectedTab = function (tabName) {
        if (!(props === null || props === void 0 ? void 0 : props.skipUpdateUrl)) {
            navigate("/dashboard/lead-dashboard", { replace: true });
        }
        props.setScrollPosition(window.pageYOffset);
        di.leads.paginationResetOnFilterApply(true);
        setTab(tabName);
        props.setFlag(tabName);
        props.getLeadDashboardData(tabName);
        props === null || props === void 0 ? void 0 : props.setSearchText("");
    };
    var handleSearchText = function (e) {
        props === null || props === void 0 ? void 0 : props.setSearchText(e.target.value);
    };
    return (React.createElement(Row, { className: "lead-tabs-row" },
        React.createElement(Col, { md: 11, lg: 11 },
            React.createElement(GenericTabs, { defaultActiveKey: tabFlag ? tabFlag : tab, tabsArray: leadTabList, externalClassName: "common-tab-color", callBackFunction: getSelectedTab })),
        React.createElement(Col, { className: "d-flex justify-content-end align-items-center folder-image", md: 1, lg: 1 }, (props === null || props === void 0 ? void 0 : props.loader) ? (React.createElement("div", { className: "spinner-box" },
            React.createElement(Spinner, { animation: "border", variant: "primary" }))) : (React.createElement("i", { className: "edel-icon-download-page hand_cursor", onClick: function () {
                return props.getLeadDashboardData(props.flag ? props.flag : tab, true);
            } },
            React.createElement("span", { className: "path1" }),
            React.createElement("span", { className: "path2" }),
            React.createElement("span", { className: "path3" }))))));
};
export default LeadViewTabs;
